import { AlertRow } from '@components/AlertCenter/AlertRows/AlertRow';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { PartnerSettingsAvatar } from '@components/AlertCenter/AlertRows/partnerSettings/PartnerSettingsAvatar';

export const OfferTermsAlertRow = () => {
  const {
    translate,
    translations: {
      alertCenter: { partnerSettings },
    },
  } = useTranslations();

  const navigate = useNavigate();

  const goToSettings = () => {
    navigate(`/system-settings/company-information?modal=offerTerms`);
  };

  return (
    <AlertRow
      Icon={<PartnerSettingsAvatar />}
      action={goToSettings}
      title={translate(partnerSettings.offerTerms.title)}
      actionText={translate(partnerSettings.offerTerms.path)}
      subtitle={translate(partnerSettings.subtitle)}
    />
  );
};
